import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import GlobalStyle from './styles/GlobalStyle';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import useUserStore from './store/userStore';
import BoardListPage from './pages/BoardListPage';
import BoardPage from './pages/BoardPage';
import CalendarPage from './pages/CalendarPage';
import AllTasksPage from "./pages/AllTasksPage";
import GanttChartPage from './pages/GanttChartPage';
import ActivityLogPage from './pages/ActivityLogPage';
import ActivityPlaybackPage from "./pages/ActivityPlaybackPage";
import ReportResponse from "./pages/ActivityReportPage";
import WebSocketManager from './components/common/WebSocketManager';
import MascotNotification from './components/common/MascotNotification';
import NotificationHistory from './components/common/NotificationHistory';
import SchedulerManager from './components/common/SchedulerManager';
import ProjectDetailPage from "./pages/ProjectDetailPage";
import SettingsPage from './pages/SettingsPage';
import ProjectListPage from "./pages/ProjectListPage";

function App() {
    const location = useLocation();
    const { isInitialized, checkAuth } = useUserStore();

    useEffect(() => {
        if (location.pathname === '/register') {
            return;
        }

        if (!isInitialized) {
            checkAuth();
        }
    }, [location.pathname, isInitialized, checkAuth]);

    // if (!isAuthChecked) {
    //     return <div>Loading...</div>;
    // }

    return (
        // <BrowserRouter>
        <>
            <GlobalStyle />
            <WebSocketManager />
            <MascotNotification />
            <NotificationHistory />
            <SchedulerManager />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/" element={<BoardListPage />} />
                <Route path="/board/:boardId/*" element={<BoardPage />} />
                <Route path="/calendar/*" element={<CalendarPage />} />
                <Route path="/tasks/*" element={<AllTasksPage />} />
                <Route path="/gantt/*" element={<GanttChartPage />} />
                <Route path="/activity" element={<ActivityLogPage />} />
                <Route path="/activity/playback" element={<ActivityPlaybackPage />} />
                <Route path="/report" element={<ReportResponse />} />
                <Route path="/projects" element={<ProjectListPage />} />
                <Route path="/projects/:projectId/*" element={<ProjectDetailPage />} />
                <Route path="/settings" element={<SettingsPage />} />

            </Routes>
        </>
        // </BrowserRouter>
    );
}

export default App;

